import create from 'zustand';
import {lastDayOfMonth} from "date-fns";

// Aktuelles Datum
const today = new Date();

// 1. Januar des aktuellen Jahres berechnen
const startOfYear = new Date(today.getFullYear(), 0, 1); // Monat ist nullbasiert, also Januar = 0

// Zustand Store zur Speicherung des Start- und Enddatums
export const useDatePickerStore = create((set) => ({
    startDate: startOfYear, // Standardmäßig auf den 1. Januar des aktuellen Jahres setzen
    endDate: lastDayOfMonth(today),
    setStartDate: (date) => set({startDate: date}),
    setEndDate: (date) => set({endDate: date}),
}));

export default useDatePickerStore;
